// extracted by mini-css-extract-plugin
export var dropdownButton = "_1a-0";
export var fullWidthDropdownButton = "_1a-1";
export var icon = "_1a-3";
export var iconPlaceholder = "_1a-2";
export var shortcutContainer = "_1a-4";